const Configuration = {
    BASE_SERVER_URL:  "https://joyntlyapi.airro.dev"
}

export default Configuration;